import { fetchList } from './utils'

export const fetchPosts = (
  page, filters, limit, language, userToken) => fetchList(page, filters, 'news', limit, language, userToken)
